<template>
  <div class="no-result">
    <div class="no-cell">
      <div><img :src="require('../assets/img/empty.png')" alt="" /></div>
      <div>数据为空</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/ocr-no-result.vue